/** Full locale it – edit as needed. */
export default {
  'nav.home': 'Home',
  'nav.seeDemo': 'Guarda la demo',
  'nav.howItWorks': 'Come funziona',
  'nav.pricing': 'Prezzi',
  'nav.aboutUs': 'Chi siamo',
  'nav.faqs': 'FAQ',
  'nav.contact': 'Contatto',
  'nav.blog': 'Blog',
  'nav.logIn': 'Accedi / Registrati',
  'nav.getStarted': 'Inizia',
  'brand.primeDocumentSign': 'Prime Document Sign',
  'hero.priceBanner': 'A partire da 2 $/mese!',
  'hero.oneAgreement': 'Solo 1 accordo da firmare? Solo 6 $ con funzioni Premium – niente abbonamento.',
  'hero.subscriptionsOnly': '( Solo abbonamenti )',
  'hero.couponBannerText': 'Codice sconto 10% a vita per i nostri primi 1000 utenti!',
  'hero.couponSubscribedOnly': '(solo abbonati)',
  'hero.couponCode': '25OFFNEWUSERS1000',
  'hero.bannerEyebrow': 'Piattaforma di firma elettronica · Piani da 2 $/mese',
  'hero.bannerHeadlinePrefix': 'Ottieni',
  'hero.bannerHeadlineMid': 'firmati',
  'hero.bannerHeadlineAccent': 'all’istante.',
  'hero.bannerCycleContracts': 'Contratti',
  'hero.bannerCycleNDAs': 'NDA',
  'hero.bannerCycleProposals': 'Proposte',
  'hero.bannerCycleDocuments': 'Documenti',
  'hero.bannerDesc':
    'Crea accordi professionali, inviali in firma elettronica e ricevi PDF firmati legalmente validi — in pochi minuti, da qualsiasi dispositivo.',
  'hero.watchDemo': 'Guarda come funziona',
  'hero.trustLocked': 'Crittografia AES-256',
  'hero.trustNoCard': 'Nessuna carta richiesta',
  'hero.trustReady': 'Attivo in 2 min',
  'hero.landingShowMore': 'Mostra di più',
  'hero.landingShowLess': 'Mostra di meno',
  'hero.tagline': 'Il modo più semplice per creare, firmare e inviare documenti — senza vincoli',
  'hero.firebaseTopAria': 'Sicurezza e hosting (Google Firebase e Google Cloud)',
  'hero.topTrustListAria': 'Sicurezza, prezzi, firma, promemoria e supporto',
  'hero.accDataSafeTitle': 'I tuoi dati sono al sicuro con noi',
  'hero.accDataSafe1':
    'Basato su Google Firebase e Google Cloud — la stessa infrastruttura enterprise usata da milioni di app',
  'hero.accDataSafe2':
    'I dati sono protetti con crittografia AES-256 a riposo e chiavi gestite da Google',
  'hero.accDataSafe3':
    'Autenticazione e gestione dei dati secondo gli standard di sicurezza di Google',
  'hero.accDataSafe4': 'Non vendiamo né condividiamo i tuoi dati — la tua privacy è rispettata',
  'hero.accDataSafe5Before': 'Trasparenza su conservazione e utilizzo (vedi la nostra ',
  'hero.accDataSafe5After': ')',
  'hero.accPricingTitle': 'Prezzi semplici — nessun costo nascosto',
  'hero.accPricing1': 'Crea accordi professionali in pochi minuti',
  'hero.accPricing2': 'Piani da soli 2 $ al mese',
  'hero.accPricing3': 'Nessun costo nascosto',
  'hero.accPricing4': 'Nessun vincolo — annulla quando vuoi',
  'hero.accPricing5': 'Ideale per freelance, startup e PMI',
  'hero.accPricing6': 'Invia il primo documento gratis',
  'hero.accSigningTitle': 'Firma veloce e semplice',
  'hero.accSigning1': 'Oltre 30 modelli pronti o carica il tuo file',
  'hero.accSigning2': 'Aggiungi campi firma e personalizza in secondi',
  'hero.accSigning3': 'Invia a più destinatari contemporaneamente',
  'hero.accSigning4': 'Salva modelli riutilizzabili',
  'hero.accSigning5': 'I firmatari non servono account — firma immediata',
  'hero.accSigning6': 'Anteprima live prima dell’invio',
  'hero.accRemindersTitle': 'Promemoria intelligenti e tracciamento',
  'hero.accReminders1': 'Promemoria automatici a 1, 3 e 7 giorni',
  'hero.accReminders2': 'Avvisi su apertura o firma',
  'hero.accReminders3': 'Segui il processo in tempo reale',
  'hero.accReminders4': 'Niente più solleciti manuali',
  'hero.accAnywhereTitle': 'Lavora da ovunque',
  'hero.accAnywhere1': 'Accedi da desktop o mobile',
  'hero.accAnywhere2': 'Invia e firma da qualsiasi dispositivo',
  'hero.accAnywhere3': 'Flessibilità — ufficio o in movimento',
  'hero.accSupportTitle': 'Supporto affidabile',
  'hero.accSupport1': 'Assistenza dedicata con risposte rapide',
  'hero.accSupport2': 'Obiettivo: risposta entro 24 ore',
  'hero.accSupport3': 'Aggiornamenti continui in base al feedback',
  'hero.firebaseTrustPrivacyLink': 'Informativa sulla privacy',
  'hero.firebaseTrustFineprintAfter':
    ' spiega conservazione, accesso e i tuoi diritti. Non vendiamo mai i tuoi dati.',
  'hero.pill': 'Invia firme elettroniche legalmente vincolanti in pochi secondi',
  'hero.headline': 'Lo strumento di firma elettronica più semplice per freelancer e piccoli team',
  'hero.ctaPrimary': 'Crea / Carica documento e invia per firma',
  'hero.ctaTrialSignup': 'Prova ora con 1 mese di prova gratuita',
  'hero.ctaFreeDocument': 'Prova subito un documento gratuito',
  'hero.ctaPrimaryNote': 'Nessuna carta di credito o dati di pagamento richiesti.',
  'hero.subscriptionTeaserBefore': 'Abbonamenti da soli ',
  'hero.subscriptionTeaserAfter': ' al mese!',
  'hero.createAccountTrialHeadline': 'Iscriviti ora e ottieni 1 mese di prova gratuita',
  'hero.createAccountPromoCopy': 'Copia codice',
  'hero.createAccountPromoCopied': 'Copiato!',
  'hero.createAccountPromoCodeAria': 'Codice promo: un mese di prova gratuita',
  'hero.createAccountNote': 'Usalo al checkout quando scegli un piano.',
  'hero.createAccountOfferLimit': '( Offerta valida solo per i nostri primi 1000 utenti )',
  'hero.desc': 'Crea, invia e monitora accordi con un\'esperienza di firma moderna.',
  'hero.getStartedFree': 'Inizia gratis',
  'hero.tryWithoutAccountButton': 'Prova senza account',
  'hero.logInSignUp': 'Accedi / Registrati',
  'hero.whyChooseUs': 'Perché sceglierci?',
  'hero.stepsTitle': 'Crea, Firma, Ricevi',
  'hero.stepsSubtitle': 'Tre semplici passaggi per creare e far firmare i documenti in pochi minuti.',
  'hero.step1Create': 'Carica o crea il tuo documento',
  'hero.step2Sign': 'Invia per la firma',
  'hero.step3Receive': 'Ricevi una notifica subito quando viene firmato',
  'hero.benefit1': 'Facile – Invia link e email di firma in secondi',
  'hero.benefit2': 'Carica PDF esistente o estrai testo e modifica con l’editor di testo avanzato',
  'hero.benefit3': 'Estrai testo da PDF e modifica',
  'hero.benefit4': 'Crea campi e layout di firma in secondi',
  'hero.benefit5': 'Invia a più destinatari contemporaneamente',
  'hero.benefit6': 'Nessun abbonamento – pagamento unico per invio',
  'hero.benefit7': 'Copia link e invia a chi vuoi',
  'hero.benefit8': 'Crea e salva modelli',
  'hero.benefit9': 'Visualizza tutti gli eventi email',
  'hero.benefit10': 'Anteprima live e PDF per audit',
  'hero.benefit11': 'Modelli con modifica flessibile',
  'hero.benefit12': 'I destinatari non devono registrarsi',
  'hero.benefit13': 'Funziona su qualsiasi dispositivo',
  'how.simpleProcess': 'Processo semplice',
  'how.title': 'Come funziona',
  'how.subtitle': 'Crea, invia e firma in tre passaggi.',
  'how.step1Title': 'Crea un modello',
  'how.step1Desc': 'Estrazione e caricamento PDF, editor di testo, campi firma (data, nome, termini, blocchi firma), layout. Salva come modello e riusa.',
  'how.step2Title': 'Invia ai destinatari',
  'how.step2Desc': 'Invia documenti via email con link di firma sicuri e univoci. Più destinatari, copia link, monitora aperture e firme.',
  'how.step3Title': 'Ricevi i PDF firmati',
  'how.step3Desc': 'Ricevi PDF firmati con traccia di audit: data, email, telefono, consenso. Email di conferma al completamento.',
  'pricing.compareHeadline': 'Perché pagare 19 €/mese per le firme elettroniche?',
  'pricing.comparePlatform': 'Piattaforma',
  'pricing.comparePrice': 'Prezzo',
  'pricing.compareUs': 'Prime Document Sign',
  'pricing.compareDocuSign': 'DocuSign',
  'pricing.compareDropboxSign': 'Dropbox Sign',
  'pricing.comparePandaDoc': 'PandaDoc',
  'pricing.comparePerMonth': '{price}/mese',
  'pricing.compareBestValue': 'Miglior valore',
  'pricing.compareWhyPayLine1': 'Invia firme elettroniche legalmente vincolanti in pochi secondi',
  'pricing.compareWhyPayLine2': 'Più di un invio? Abbonamenti da 2 $ al mese',
  'pricing.compareBenefitSingle': 'Invia documenti singoli',
  'pricing.compareBenefitNoContract': 'Nessun contratto costoso',
  'pricing.compareBenefitPayWhenNeed': 'Paga solo quando serve',
  'pricing.compareBenefitTemplates': 'Scegli tra oltre 30 modelli',
  'pricing.compareDisclaimer': 'Prezzi concorrenti basati su piani starter pubblici; possono variare.',
  'trust.secureLinks': 'Link di firma unici e sicuri per ogni documento',
  'trust.auditTrail': 'Traccia di audit completa su ogni firma (chi, quando, IP)',
  'trust.verifiablePdfs': 'PDF firmati verificabili da conservare',
  'trust.footer': 'Scelto da freelancer e piccole imprese in tutto il mondo',
  'useCases.title': 'Perfetto per ( Modelli pronti )',
  'useCases.freelancers': 'Freelancer che inviano contratti',
  'useCases.agencies': 'Agenzie che firmano accordi',
  'useCases.landlords': 'Proprietari che inviano contratti di affitto',
  'useCases.startups': 'Startup che firmano NDA',
  'useCases.carBoat': 'Vendere auto o barca con documento legale',
  'useCases.consultants': 'Consulenti e indipendenti',
  'useCases.equipmentRental': 'Noleggio attrezzature con accordo formale',
  'useCases.contractors': 'Appaltatori indipendenti che formalizzano incarichi',
  'useCases.website': 'Accordi per progetti web e digitali',
  'pricing.title': 'Prezzi',
  'pricing.billAnnually': 'Fatturazione annuale',
  'pricing.billMonthly': 'Fatturazione mensile',
  'pricing.getStarted': 'Inizia',
  'pricing.mostPopular': 'PIÙ POPOLARE',
  'pricing.billedPerYear': '${amount}/anno',
  'pricing.perMonth': '/mese',
  'pricing.tierBasic': 'Base',
  'pricing.tierStandard': 'Standard',
  'pricing.tierPremium': 'Premium',
  'pricing.descBasic': 'Per uso occasionale.',
  'pricing.descStandard': 'Per team in crescita.',
  'pricing.descPremium': 'Per utenti avanzati.',
  'about.label': 'Perché sceglierci',
  'about.title': 'Chi siamo',
  'about.subtitle': 'Rendiamo i flussi di firma semplici, veloci e sicuri.',
  'about.speed': 'Velocità',
  'about.builtForSpeed': 'Progettato per la velocità',
  'about.builtForSpeedDesc': 'Interfaccia moderna: crea e invia documenti in minuti. Firma da qualsiasi dispositivo.',
  'about.security': 'Sicurezza',
  'about.dataSecurity': 'Sicurezza dei dati',
  'about.dataSecurityTitle': 'Ospitato su Google Firebase e Google Cloud',
  'about.dataSecurityDesc': 'I dati del tuo account, documenti, modelli e attività di firma sono elaborati su Google Firebase e Google Cloud, piattaforme pensate per app in produzione che richiedono autenticazione e archiviazione solide. Il traffico usa HTTPS (TLS) end-to-end; i dati a riposo sono crittografati con chiavi gestite da Google (incluso AES-256). Gli accessi usano Firebase Authentication e le regole di sicurezza di Firestore aiutano a garantire che letture e scritture corrispondano al tuo account, così il tuo spazio di lavoro resta isolato e non leggibile da tutta Internet. Lo stack gira sulla rete globale di Google con monitoraggio, patch e pratiche di durata descritte nella documentazione Google, e non vendiamo i tuoi dati personali né il contenuto dei documenti a broker o inserzionisti. Per subfornitori, conformità e diritti, consulta l\'Informativa sulla privacy.',
  'about.dataSecurityPrivacyCta': 'Leggi l\'Informativa sulla privacy completa →',
  'about.privacyPill': 'Privacy',
  'about.privacyFocused': 'Privacy al centro',
  'about.privacyFocusedDesc': 'Ogni link di firma è univoco: i destinatari vedono solo ciò che invii. I PDF firmati includono una chiara audit trail da archiviare: chi ha firmato, quando e il consenso dato, così privacy e prova vanno insieme.',
  'about.teams': 'Singoli e team',
  'about.madeForTeams': 'Per singoli e team',
  'about.madeForTeamsDesc': 'Modelli per tutti: testo, titoli, elenchi, campi firma, data, nome, campi personalizzati. Salva e riusa i modelli.',
  'about.sectionHeadlineBefore': 'Progettato per ',
  'about.sectionHeadlineAccent': 'fiducia e velocità',
  'about.firebaseVisualBadge': 'Google Firebase · Google Cloud',
  'faq.title': 'FAQ',
  'faq.searchHint': 'Cerca per parola chiave per trovare rapidamente le FAQ',
  'faq.searchPlaceholder': 'es. PDF, modello, firma...',
  'faq.noResults': 'Nessuna FAQ corrisponde alla ricerca. Prova altre parole.',
  'faq.more': 'Altro',
  'faq.less': 'Meno',
  'faq.eyebrow': 'Hai domande?',
  'faq.titleBefore': 'Domande ',
  'faq.titleAccent': 'frequenti',
  'faq.subtitleLead': 'Tutto ciò che devi sapere su Prime Document Sign. Non trovi la risposta? ',
  'faq.subtitleLink': 'Scrivici.',
  'faq.clearSearchAria': 'Cancella ricerca',
  'faq.subscriptionsWorkQ': 'Come funzionano gli abbonamenti?',
  'faq.subscriptionsWorkA': 'Piano Premium (${{monthly}} $/mese o ${{annual}} $/anno). Pagamento unico per invio possibile. Abbonamenti via Stripe. Gestisci in Il mio account → Il mio abbonamento.',
  'faq.upgradePlanQ': 'Come aggiorno il piano?',
  'faq.upgradePlanA': 'Il mio account → Il mio abbonamento, seleziona un piano superiore e conferma. Aggiornamento in genere immediato.',
  'faq.downgradePlanQ': 'Come downgrade?',
  'faq.downgradePlanA': 'Il mio account → Il mio abbonamento, seleziona un piano inferiore. Effetto all\'inizio del prossimo ciclo.',
  'faq.cancelPlanQ': 'Come annullo l\'abbonamento?',
  'faq.cancelPlanA': 'Il mio account → Il mio abbonamento, annulla tramite portale Stripe o contatta il supporto. Annullamento a fine periodo.',
  'faq.oneTimeOptionQ': 'Cos\'è il pagamento unico per invio?',
  'faq.oneTimeOptionA': 'Invio occasionale: ${{oneTimePrice}} $ per invio invece dell\'abbonamento. Funzioni Premium per quell\'invio. Scegli alla registrazione o in Il mio abbonamento.',
  'faq.emailLimitQ': 'Cosa succede al limite email mensile?',
  'faq.emailLimitA': 'Base: 5 email/mese, Standard: 50, Premium: 150. Limite si resetta ogni mese. Al limite: acquista più crediti o aggiorna.',
  'faq.yearlyBillingQ': 'Fatturazione annuale?',
  'faq.yearlyBillingA': 'Sì. Premium: ${{monthly}} $/mese o ${{annual}} $/anno. L\'annuale risparmia fino al {{discountPercent}}%. Cambia in Il mio abbonamento.',
  'faq.multipleRecipientsQ': 'Più destinatari?',
  'faq.multipleRecipientsA': 'Sì. Base: fino a 5, Standard e Premium: fino a 10. Email separate da virgole. Ognuno riceve un link univoco. Nessun account richiesto.',
  'faq.reuseTemplatesQ': 'Riutilizzare i modelli?',
  'faq.reuseTemplatesA': 'Base: 3, Standard: 10, Premium: 25 modelli. Cronologia modelli (Il mio account) per caricare i modelli.',
  'faq.recipientAccountQ': 'Il destinatario ha bisogno di un account?',
  'faq.recipientAccountA': 'No. Il destinatario riceve l\'email con il link e può firmare dal dispositivo. Nessun account. Desktop, tablet, mobile.',
  'faq.confirmationEmailQ': 'Email di conferma?',
  'faq.confirmationEmailA': 'Sì. Al completamento, email con PDF firmato. Ogni PDF include traccia di audit.',
  'faq.previewPdfQ': 'Anteprima PDF prima dell\'invio?',
  'faq.previewPdfA': 'Sì. Pulsante Anteprima PDF per vedere il layout. Poi invia o copia il link.',
  'faq.editAgreementQ': 'Modificare il testo dell\'accordo?',
  'faq.editAgreementA': 'Sì. Editor di testo per titoli, elenchi, grassetto, corsivo, sottolineato. Carica PDF per estrarre o visualizzare.',
  'faq.signatureRequiredQ': 'Firma obbligatoria?',
  'faq.signatureRequiredA': 'Sì. I destinatari devono compilare data, nome, casella termini e firma. Requisiti di validità legale.',
  'faq.attachmentsQ': 'Quanti allegati?',
  'faq.attachmentsA': 'Base: nessuno. Standard: 3 (8 MB totali). Premium: 10 (8 MB totali). Inviati con il link di firma.',
  'faq.emailActivityQ': 'Attività email (Premium)?',
  'faq.emailActivityA': 'Premium: Attività email in Il mio account. Quali documenti, quando, a chi. Conformità.',
  'faq.emailRemindersQ': 'Come funzionano i promemoria email?',
  'faq.emailRemindersA': 'Nel generatore di documenti, passaggio 4 (Funzioni aggiuntive), puoi attivare promemoria a 1, 3 e/o 7 giorni per ogni invio. Dopo la prima email di firma, inviamo un promemoria solo se quel destinatario non ha ancora completato il documento. I promemoria si interrompono automaticamente alla firma. Le email di promemoria compaiono nell\'attività email con data e ora; non contano nel limite mensile di invii.',
  'faq.defaultSenderQ': 'Email mittente predefinita?',
  'faq.defaultSenderA': 'Il mio account → Dettagli account, inserisci l\'email e salva. Si compila automaticamente all\'invio.',
  'faq.mobileSignQ': 'Firmare su mobile?',
  'faq.mobileSignA': 'Sì. Esperienza responsive. Apri il link su smartphone o tablet, firma con dito o stylus.',
  'faq.getHelpQ': 'Come ottenere aiuto?',
  'faq.getHelpA': 'Supporto in Il mio account o modulo di contatto. Rispondiamo il prima possibile.',
  'faq.dataSecureQ': 'I miei dati sono sicuri?',
  'faq.dataSecureA': 'Sì. Pratiche standard per proteggere documenti e informazioni.',
  'faq.fileFormatsQ': 'Quali formati di file?',
  'faq.fileFormatsA': 'Documenti creati nell\'editor di testo. Accordi completati in PDF.',
  'faq.deleteTemplateQ': 'Cosa succede se elimino un modello?',
  'faq.deleteTemplateA': 'I modelli eliminati sono rimossi in modo permanente. Verifica prima di eliminare. Crea un nuovo modello in qualsiasi momento.',
  'faq.ownLogoQ': 'Posso aggiungere il mio logo?',
  'faq.ownLogoA': 'Sì, sui piani Standard e Premium. Carica il logo (fino a 20 KB) e scegli la posizione. Base non incluso.',
  'faq.uploadPdfQ': 'Come carico un PDF?',
  'faq.uploadPdfA': 'Nel creatore documenti, usa l\'opzione Carica PDF (piani Standard e Premium). Il PDF viene mostrato sopra o accanto al testo. I destinatari vedono il documento completo alla firma.',
  'faq.extractPdfQ': 'Cos\'è l\'estrazione PDF e come funziona?',
  'faq.extractPdfA': 'L\'estrazione PDF (Standard e Premium) estrae il testo da un PDF esistente nell\'editor per modificarlo. Carica il PDF, scegli Estrai testo, il contenuto viene copiato. Poi modifica e aggiungi campi firma.',
  'faq.richTextEditorQ': 'Cosa posso fare con l\'editor di testo?',
  'faq.richTextEditorA': 'L\'editor permette di creare e formattare accordi: titoli, grassetto, corsivo, liste, dimensioni font. Aggiungi blocchi firma sotto. Tutto a clic, senza codice.',
  'faq.previewWhenQ': 'Quando fare l\'anteprima prima di inviare?',
  'faq.previewWhenA': 'Usa sempre Anteprima PDF prima di inviare. Mostra il layout esatto: testo, blocchi firma, data, nome. Controlla la formattazione e poi invia o copia il link.',
  'faq.documentLifetimeQ': 'Quanto durano i link di firma? Posso chiedere una proroga?',
  'faq.documentLifetimeA': 'I link restano attivi circa 30 giorni. Scarica e salva il PDF firmato prima della scadenza. Se un link è scaduto, contatta il mittente per richiedere una nuova email con un link fresco.',
  'faq.editLayoutQ': 'Come modifico il layout della firma?',
  'faq.editLayoutA': 'Usa Modifica layout nella sezione firma per riordinare i campi. Trascina data, nome, condizioni, blocchi firma e campi personalizzati. Aggiungi spaziatori e scegli il numero di colonne.',
  'faq.customFieldsQ': 'Come aggiungo campi personalizzati (testo, data, checkbox, ecc.)?',
  'faq.customFieldsA': 'Clicca Aggiungi campo personalizzato. Scegli etichetta e tipo: Testo, Numero, Data, Ora, Lista, Checkbox o Firma. Fino a 10 campi per documento. Indica quali firmatari vedono ogni campo, poi Modifica layout.',
  'faq.multipleSignaturesQ': 'Posso aggiungere 2 o più firme (più firmatari)?',
  'faq.multipleSignaturesA': 'Sì. Usa la sezione Destinatari per aggiungere un secondo firmatario. Ognuno riceve un link unico e il proprio blocco firma. Base: fino a 5; Standard e Premium: fino a 10 destinatari per invio.',
  'faq.documentBuilderTipsQ': 'Cosa posso fare nel creatore documenti?',
  'faq.documentBuilderTipsA': 'Creare accordi, caricare o estrarre PDF, aggiungere blocchi firma, campi personalizzati e allegati. Modificare layout, salvare modelli, anteprima PDF. Le modifiche si salvano automaticamente.',
  'faq.clearEverythingQ': 'Cosa fa Cancella tutto?',
  'faq.clearEverythingA': 'Cancella tutto resetta il creatore: testo, blocchi firma, campi personalizzati e allegati. Usalo per ricominciare da zero. I modelli salvati non sono interessati.',
  'faq.forgotPasswordQ': 'Ho dimenticato la password. Come la reimposto?',
  'faq.forgotPasswordA': 'Nella schermata di accesso: Password dimenticata? Inserisci l\'email e invia il link. Controlla inbox e spam. Il link scade—richiedine uno nuovo se serve. Accedi con la nuova password.',
  'faq.saveTemplateQ': 'Come salvo un documento come modello?',
  'faq.saveTemplateA': 'Crea il documento, poi clicca Salva modello. Assegna un nome e Salva come nuovo. Compare in Cronologia modelli (Il mio account). Per aggiornare: carica il modello, modifica, poi Salva modello → Aggiorna modello.',
  'faq.loadTemplateQ': 'Come carico un modello dalla cronologia?',
  'faq.loadTemplateA': 'Il mio account → Cronologia modelli. Clicca sul modello desiderato. Si apre nel creatore con contenuto e layout. Modifica se serve, aggiungi destinatari e invia.',
  'faq.templateLimitsQ': 'Quanti modelli posso salvare?',
  'faq.templateLimitsA': 'Base: 3, Standard: 10, Premium: 25 modelli. Ogni modello salva testo, formattazione, blocchi firma e layout. Al limite: elimina uno vecchio o migliora il piano.',
  'faq.recipientNoEmailQ': 'Il destinatario non ha ricevuto l\'email di firma?',
  'faq.recipientNoEmailA': 'Chiedigli di controllare lo spam. Usa Copia link per ottenere l\'URL e condividerla manualmente (SMS, Slack, ecc.). Oppure reinvia il documento alla stessa email per un nuovo link.',
  'faq.editAfterSendQ': 'Posso modificare un documento dopo averlo inviato?',
  'faq.editAfterSendA': 'No. Una volta inviato, il contenuto è bloccato. Per modificare: crea un nuovo documento con le modifiche e invialo. Le bozze non inviate si possono modificare liberamente.',
  'faq.changeAccountQ': 'Come modifico email o password?',
  'faq.changeAccountA': 'Il mio account → Dettagli account. Aggiorna email o password. Per la password: inserisci quella attuale e la nuova. Usa Password dimenticata? se non la ricordi.',
  'faq.browserSupportQ': 'Quali browser e dispositivi sono supportati?',
  'faq.browserSupportA': 'Chrome, Firefox, Safari, Edge (desktop e mobile). Firma responsive su smartphone e tablet. Usa versioni recenti. Nessuna app da scaricare.',
  'faq.copyLinkQ': 'Come copio un link per condividere invece di inviare email?',
  'faq.copyLinkA': 'Dopo aver creato il documento, clicca Copia link. L\'URL viene copiato. Incollalo in un messaggio, email o Slack. Il destinatario può firmare senza ricevere email da noi.',
  'faq.resendDocumentQ': 'Posso reinviare un documento se il destinatario non ha firmato?',
  'faq.resendDocumentA': 'Sì. Invia di nuovo lo stesso documento allo stesso o altro indirizzo. Ogni invio crea un nuovo link. Se il link originale è scaduto, reinviare dà un link fresco. Usa Attività email (Premium) per tracciare gli invii.',
  'testimonials.eyebrow': 'TESTIMONIANZE',
  'testimonials.title': 'Cosa dicono i nostri clienti.',
  'testimonials.quote1': 'Il costo è il più basso. Miglior rapporto qualità-prezzo e facile da usare.',
  'testimonials.quote2': 'Accordo incollato da ChatGPT, modificato in pochi minuti, inviato per firma. Fatto in meno di 10 minuti.',
  'testimonials.quote3': 'Tutto dal telefono. Documento creato, campi firma aggiunti, inviato in viaggio.',
  'testimonials.quote4': 'Facile e prezzi equi. Nessun costo nascosto. Il mio team lo usa per contratti e NDA.',
  'testimonials.quote5': 'Testo del contratto incollato, blocchi firma aggiunti, inviato. Firmato lo stesso giorno.',
  'testimonials.quote6': 'Su laptop e telefono. Esperienza fluida. Miglior valore per la firma elettronica.',
  'testimonials.prev': 'Indietro',
  'testimonials.next': 'Avanti',
  'contact.title': 'Contattaci',
  'contact.subtitle': 'Hai domande? Ci piacerebbe sentirti.',
  'contact.eyebrow': 'Mettiti in contatto',
  'contact.headlineBefore': 'Parliamo ',
  'contact.headlineAccent': 'insieme',
  'contact.responseTimeLabel': 'Tempo di risposta',
  'contact.responseTimeValue': 'Entro 24 ore',
  'contact.secureLabel': 'Sicuro e privato',
  'contact.secureValue': 'Crittografia AES-256',
  'contact.trustNoSpam': 'Mai spam',
  'contact.trustHumanSupport': 'Supporto umano reale',
  'contact.firstName': 'Nome',
  'contact.lastName': 'Cognome',
  'contact.email': 'Email',
  'contact.message': 'Messaggio',
  'contact.sendMessage': 'Invia messaggio',
  'contact.required': '*',
  'contact.placeholderFirst': 'Il tuo nome',
  'contact.placeholderLast': 'Il tuo cognome',
  'contact.placeholderEmail': 'La tua email',
  'contact.placeholderMessage': 'Dicci come possiamo aiutare…',
  'contact.attachments': 'Allegati',
  'contact.attachmentsHint': 'Fino a 5 file, 2 MB totali',
  'contact.addFiles': '+ Aggiungi file',
  'contact.addAttachmentsAria': 'Aggiungi allegati',
  'auth.forgotPassword': 'Password dimenticata?',
  'auth.backToLogIn': 'Torna al login',
  'auth.sendResetLink': 'Invia link di reimpostazione',
  'auth.checkEmailReset': 'Controlla la tua email per il link.',
  'auth.emailLabel': 'Email',
  'auth.passwordLabel': 'Password',
  'auth.firstNameLabel': 'Nome',
  'auth.lastNameLabel': 'Cognome',
  'auth.enterEmail': 'Inserisci la tua email.',
  'auth.enterEmailPassword': 'Inserisci email e password.',
  'auth.passwordMinLength': 'La password deve avere almeno 8 caratteri.',
  'auth.passwordSpecial': 'La password deve includere un carattere speciale.',
  'auth.passwordsNoMatch': 'Le password non corrispondono.',
  'auth.signInWithGoogle': 'Accedi con Google',
  'auth.or': 'o',
  'auth.logInFailed': 'Accesso fallito.',
  'auth.signUpFailed': 'Registrazione fallita.',
  'auth.emailAlreadyInUse': 'Questa email è già in uso.',
  'connectionError.message': 'Problema di connessione. Controlla la connessione internet e aggiorna la pagina.',
  'connectionError.refresh': 'Aggiorna pagina',
  'connectionError.tooManyRequests': 'Troppi tentativi. Riprova più tardi.',
  'auth.emailPlaceholder': 'mario@esempio.it',
  'auth.passwordPlaceholder': 'Inserisci la password',
  'auth.firstNamePlaceholder': 'Mario',
  'auth.lastNamePlaceholder': 'Rossi',
  'auth.manageSubscription': 'Gestisci abbonamento',
  'auth.subscribe': 'Abbonati',
  'auth.signUpForSubscription': 'Registrati per l\'abbonamento',
  'auth.currentPlan': 'PIANO ATTUALE',
  'auth.updatePlanHint': 'Aggiorna il piano in Stripe per più crediti mensili.',
  'auth.updatePlanStripe': 'Aggiorna piano, metodo di pagamento o annulla nel portale Stripe.',
  'auth.subscribeToPlan': 'Abbonati a un piano per iniziare.',
  'auth.topUpCredits': 'Acquista crediti ({{label}}: ${{price}})',
  'pricing.featureRecipients5': 'Fino a 5 destinatari per invio',
  'pricing.featureRecipients10': 'Fino a 10 destinatari per invio',
  'pricing.featureEmails5': 'Max 5 email/mese',
  'pricing.featureEmails50': 'Max 50 email/mese',
  'pricing.featureEmails150': 'Max 150 email/mese',
  'pricing.featureTemplates3': '3 modelli',
  'pricing.featureTemplates10': '10 modelli',
  'pricing.featureTemplates25': '25 modelli',
  'pricing.featureChars3k': 'Limite 3.000 caratteri',
  'pricing.featureChars20k': 'Limite 20.000 caratteri',
  'pricing.featureChars30k': 'Limite 30.000 caratteri',
  'pricing.featureAttachmentsNone': 'Nessun allegato',
  'pricing.featureAttachments3': '3 allegati (8 MB)',
  'pricing.featureAttachments10': '10 allegati (8 MB)',
  'pricing.featurePdfUpload': 'Caricamento PDF completo',
  'pricing.featureAuditTrail': 'Traccia di audit completa',
  'pricing.featurePdfExtract': 'Estrai e modifica testo PDF',
  'pricing.featureCustomFields': 'Crea campi e modifica layout',
  'pricing.featureCopyLink': 'Copia link per firmare',
  'pricing.featureLogo': 'Carica logo personalizzato',
  'pricing.featureVerification': 'Verifica destinatario',
  'app.createYourDocument': 'Crea il tuo documento',
  'app.backToApp': 'Torna all\'app',
  'app.backToMainSite': 'Torna al sito',
  'app.backShort': 'Indietro',
  'app.myAccount': 'Il mio account',
  'app.saveTemplate': 'Salva modello',
  'app.templatesUsed': 'Modelli usati',
  'app.templatesUsedSaved': '{{count}} modelli salvati',
  'app.startFromTemplate': 'Inizia da modello',
  'app.startFromTemplateHint': 'Scegli un modello per compilare il documento. Puoi modificarlo dopo la selezione.',
  'app.signedInAs': 'Accesso come',
  'app.sendCredits': 'Crediti invio',
  'app.freeSendBanner': 'Hai 1 invio email gratuito — usalo per inviare il documento da firmare. Abbonati quando vuoi per altro.',
  'app.creditEqualsSend': '1 credito = 1 invio email',
  'app.topUpCredits': 'Acquista crediti',
  'app.emailSends': 'invii email',
  'app.signedAgreements': 'accordi firmati',
  'app.usedAfterAllowance': '(utilizzati oltre la quota mensile)',
  'app.sendForSignature': 'Invia per firma',
  'app.recipientsSection': 'Invia a',
  'app.fromNameOrg': 'Nome / Organizzazione mittente',
  'app.fromNamePlaceholder': 'Nome o organizzazione',
  'app.fromEmail': 'Email mittente',
  'app.fromEmailPlaceholder': 'Indirizzo email mittente',
  'app.recipientEmail': 'Email destinatario',
  'app.recipientHint': 'Separate da virgola, fino a {{max}} destinatari',
  'app.recipientPlaceholder': 'Indirizzo email destinatario',
  'app.recipientTooltip': 'Esempio: a@b.com, c@d.com, e@f.com',
  'app.previewPdf': 'Anteprima PDF',
  'app.clearEverything': 'Cancella tutto',
  'app.clearEverythingTitle': 'Cancella documento, destinatari e bozza salvata',
  'app.copyLink': 'Copia link',
  'app.copyLinkSubscribersOnly': 'Copia link (solo per abbonati)',
  'app.generatingLink': 'Generazione link…',
  'app.sendEmail': 'Invia email',
  'app.agreementText': 'Testo dell\'accordo',
  'app.uploadPdfExtract': 'Carica PDF per estrarre testo',
  'app.fullPdfUpload': 'Caricamento PDF completo',
  'app.agreementPlaceholder': 'Clicca qui per iniziare e creare il testo dell\'accordo...',
  'app.attachments': 'Allegati',
  'app.attachmentsHint': 'Aggiungi fino a 10 file, max 8 MB totali per l\'invio.',
  'app.addAttachment': '+ Aggiungi allegato',
  'app.signatureSection': 'Sezione firma',
  'app.totalSignatures': 'Firme totali',
  'app.createNewField': 'Crea nuovo campo',
  'app.addField': 'Aggiungi campo',
  'app.layout': 'Layout',
  'app.editLayout': 'Modifica layout',
  'app.addFieldTooltip': 'Aggiungi un campo personalizzato (testo, data, casella o firma) al blocco firma. Il nuovo campo apparirà nel layout e può essere riordinato o rimosso con Modifica layout. Fino a {{max}} campi personalizzati.',
  'app.date': 'Data',
  'app.datePlaceholder': 'aaaa/mm/gg',
  'app.termsConditions': 'Termini e condizioni',
  'app.fullName': 'Nome completo',
  'app.fullNamePlaceholder': 'Inserisci nome completo',
  'app.signature': 'Firma',
  'app.clickToSign': 'Clicca per firmare',
  'app.termsAgree': 'Accetto tutti i termini e le condizioni.',
  'app.phone': 'Telefono',
  'app.phonePlaceholder': 'Inserisci numero di telefono',
  'app.enterFieldPlaceholder': 'Inserisci {{label}}',
  'app.enterNumber': 'Inserisci numero',
  'app.selectOption': 'Seleziona...',
  'app.noFields': 'Nessun campo',
  'app.newDocument': 'Nuovo documento',
  'app.templateLabel': 'Modello: {{name}}',
  'app.forSubscribersOnly': 'Solo per utenti abbonati',
  'app.emailCredits': 'Crediti email',
  'app.creditHintDeliver': '1 credito = 1 invio — clicca Invia per consegnare',
  'app.skipAuthTesting': 'Salta auth (per test)',
  'app.agreementRequired': 'Testo dell\'accordo o caricamento PDF obbligatorio.',
  'app.agreementOrPdfRequired': 'Testo dell\'accordo o un documento PDF è obbligatorio.',
  'app.loadingPdf': 'Caricamento PDF…',
  'app.clearConfirmTitle': 'Cancella tutto',
  'app.clearConfirmMessage': 'Cancellare tutti i campi e gli allegati?',
  'app.cancel': 'Annulla',
  'app.clear': 'Cancella',
  'app.clearConfirmButton': 'Sì, cancella tutto',
  'footer.tagline': 'Firma elettronica sicura per utenti moderni.',
  'footer.product': 'Prodotto',
  'footer.templates': 'Modelli',
  'footer.company': 'Azienda',
  'footer.contactSupport': 'Supporto',
  'footer.copyright': '© 2026 primedocumentsign. Tutti i diritti riservati.',
  'footer.terms': 'Termini di servizio',
  'footer.privacy': 'Informativa sulla privacy',
  'auth.logIn': 'Accedi',
  'auth.loggingIn': 'Accesso in corso…',
  'auth.getStarted': 'Inizia',
  'auth.signUp': 'Registrati',
  'auth.logInToManage': 'Accedi per gestire e inviare documenti da firmare.',
  'auth.startSending': 'Inizia a inviare documenti con un piano di abbonamento semplice.',
  'auth.termsConfirmStart': 'Confermo di aver letto e accettato i',
  'auth.termsConfirmEnd': '.',
  'auth.termsMustAccept': 'Accetta i Termini di servizio per creare un account.',
  'email.signSubject': 'Si prega di firmare questo accordo',
  'email.signTitle': 'Documento da firmare',
  'email.signSubtitle': 'Ti è stato chiesto di firmare un documento',
  'email.fromLabel': 'Da',
  'email.signBody': 'Clicca il pulsante qui sotto per aprire il documento e aggiungere la tua firma. Qualsiasi destinatario può usare questo link per accedere e firmare — nessun account o abbonamento richiesto.',
  'email.signButton': 'Firma documento',
  'email.copyLink': 'Oppure copia questo link:',
  'email.ignoreNote': 'Se non ti aspettavi questa email, puoi ignorarla.',
  'modal.editFieldLayout': 'Modifica layout campi',
  'modal.editFieldLayoutHint': 'Trascina i campi per riordinarli o spostarli tra le colonne.',
  'modal.columns': 'Colonne',
  'modal.col': '{{n}} col',
  'modal.addSpace': 'Aggiungi spazio',
  'modal.addField': 'Aggiungi campo',
  'modal.fields': 'Campi',
  'modal.leftColumn': 'Colonna sinistra',
  'modal.rightColumn': 'Colonna destra',
  'modal.removeFromLayout': 'Rimuovere {{name}} dal layout?',
  'modal.space': 'spazio',
  'modal.yesRemove': 'Sì, rimuovi',
  'modal.keepIt': 'Mantieni',
  'modal.emptySpace': 'Spazio vuoto',
  'modal.dropFieldsHere': 'Rilascia i campi qui',
  'modal.removedFromLayout': 'Rimosso dal layout — clicca + per ripristinare',
  'modal.saveLayout': 'Salva layout',
  'modal.removeFromLayoutTitle': 'Rimuovi dal layout',
  'modal.restoreToLayout': 'Ripristina nel layout',
  'modal.editCustomField': 'Modifica campo personalizzato',
  'modal.editCustomFieldHint': 'Modifica etichetta, tipo o quali firmatari vedono questo campo.',
  'modal.addCustomField': 'Aggiungi campo personalizzato',
  'modal.addCustomFieldHint': 'Crea un nuovo campo nel modulo di firma. Max 10 campi personalizzati.',
  'modal.fieldLabel': 'Etichetta campo',
  'modal.fieldLabelPlaceholder': 'es. Nome azienda',
  'modal.fieldType': 'Tipo di campo',
  'modal.displayContent': 'Contenuto visualizzato (solo lettura per destinatario, max 100 caratteri)',
  'modal.displayContentPlaceholder': 'es. Consulta i termini qui sotto',
  'modal.picklistOptions': 'Opzioni elenco (max 10)',
  'modal.typeAndPressAdd': 'Digita e premi Aggiungi',
  'modal.add': 'Aggiungi',
  'modal.addedToSignature': 'Aggiunto alla firma',
  'modal.addedToSignatureHint': 'Seleziona le caselle sotto per aggiungere il nuovo campo al layout firma',
  'modal.signature1': 'Firma 1',
  'modal.signature2': 'Firma 2',
  'modal.close': 'Chiudi',
  'modal.save': 'Salva',
  'modal.fieldLabelRequired': 'L\'etichetta del campo è obbligatoria',
  'modal.displayContentRequired': 'Il contenuto visualizzato è obbligatorio per Testo',
  'modal.picklistOptionRequired': 'Aggiungi almeno un\'opzione',
  'modal.selectOneSignature': 'Seleziona almeno una firma',
  'modal.signingSectionExceed': 'La sezione firma supererebbe il limite di {{limit}} KB. Rimuovi del contenuto.',
  'modal.link': 'Link',
  'modal.linkTitle': 'Titolo link',
  'modal.linkUrl': 'URL link',
  'modal.linkTextPlaceholder': 'Testo del link',
  'modal.linkUrlPlaceholder': 'https://example.com',
  'modal.agreementSizeLimitReached': 'Limite dimensione accordo raggiunto',
  'modal.characterLimitReached': 'Limite caratteri raggiunto',
  'modal.agreementSizeLimitMessage': 'Hai raggiunto la dimensione massima dell\'accordo ({{max}} KB). Rimuovi contenuto o immagini prima di aggiungerne altro.',
  'modal.characterLimitMessage': 'Hai raggiunto il limite di caratteri ({{max}}). Rimuovi del testo prima di aggiungerne altro.',
  'modal.signingSectionLimitReached': 'Limite sezione firma raggiunto',
  'modal.signingSectionLimitMessage': 'Hai raggiunto la dimensione massima della sezione firma ({{limit}} KB). Rimuovi valori, firme o campi personalizzati.',
  'modal.ok': 'OK',
  'modal.addYourSignature': 'Aggiungi la tua firma',
  'modal.signatureHint': 'Usa il mouse o il trackpad per firmare.',
  'modal.clear': 'Cancella',
  'modal.saveSignature': 'Salva firma',
  'modal.removeAttachment': 'Rimuovi allegato',
  'modal.removeAttachmentConfirm': 'Rimuovere "{{name}}" da questo documento?',
  'modal.yesRemoveLabel': 'Sì, rimuovi',
  'modal.removeLogo': 'Rimuovi logo',
  'modal.removeLogoConfirm': 'Rimuovere il logo da questo documento?',
  'modal.textDisplay': 'Testo visualizzato',
  'modal.picklist': 'Elenco',
  'modal.number': 'Numero',
  'modal.time': 'Ora',
  'modal.editLabel': 'Modifica etichetta',
  'modal.editField': 'Modifica campo',
  'modal.text': 'Testo',
  'modal.checkbox': 'Casella',
  'modal.date': 'Data',
  'modal.signature': 'Firma',
  'modal.typeHasDataHint': 'Il tipo non può essere modificato perché il campo ha già dati.',
  'modal.typeHasDataTitle': 'Tipo non modificabile quando il campo ha dati',
  'modal.noKeepIt': 'No, mantieni',
  'modal.yesDelete': 'Sì, elimina',
  'modal.deleteTemplate': 'Elimina modello',
  'modal.deleteTemplateConfirm': 'Eliminare "{{name}}"? Questa azione non può essere annullata.',
  'modal.removeAttachmentFromMessage': 'Rimuovere "{{name}}" dal messaggio?',
  'modal.readyToSend': 'Pronto per l\'invio?',
  'modal.recipientsLabel': 'Destinatari:',
  'modal.readyToSendSubtitle': 'Hai controllato il documento e sei pronto per l\'invio? I seguenti destinatari riceveranno questa email:',
  'modal.readyToSendNote': 'In fase di download del PDF: la firma potrebbe essere tagliata se lo spazio non è corretto. Controlla e regola prima di inviare.',
  'modal.no': 'No',
  'modal.yesSend': 'Sì, invia',
  'modal.accountAlreadyExists': 'Account già esistente',
  'modal.accountAlreadyExistsMessage': 'Questa email è già registrata. Vuoi accedere o registrarti con un\'altra email?',
  'modal.useDifferentEmail': 'Usa un\'altra email',
  'modal.logIn': 'Accedi',
  'modal.logOut': 'Esci?',
  'modal.logOutSubtitle': 'Vuoi uscire?',
  'modal.yesLogOut': 'Sì, esci',
  'lang.en': 'Inglese',
  'lang.es': 'Spagnolo',
  'lang.pt': 'Portoghese',
  'lang.ja': 'Giapponese',
  'lang.zh': 'Cinese',
  'lang.hi': 'Hindi',
  'lang.fr': 'Francese',
  'lang.it': 'Italiano',
  'lang.de': 'Tedesco',
  'lang.ar': 'Arabo',

  'templates.starter.nda.name': 'Accordo di riservatezza (NDA)',
  'templates.starter.nda.scopeTitle': 'Accordo di riservatezza',
  'templates.starter.freelance.name': 'Contratto di servizi freelance',
  'templates.starter.freelance.scopeTitle': 'Contratto di servizi freelance',
  'templates.starter.vehicle.name': 'Contratto di vendita veicolo',
  'templates.starter.vehicle.scopeTitle': 'Contratto di vendita veicolo',
  'templates.starter.rental.name': 'Contratto di locazione residenziale',
  'templates.starter.rental.scopeTitle': 'Contratto di locazione residenziale',
  'templates.starter.recruitment.name': 'Contratto di servizi di reclutamento',
  'templates.starter.recruitment.scopeTitle': 'Contratto di servizi di reclutamento',
  'templates.starter.loan.name': 'Accordo di prestito',
  'templates.starter.loan.scopeTitle': 'Accordo di prestito',
  'templates.starter.website.name': 'Contratto di sviluppo siti web',
  'templates.starter.website.scopeTitle': 'Contratto di sviluppo siti web',
  'templates.starter.roommate.name': 'Accordo di convivenza',
  'templates.starter.roommate.scopeTitle': 'Accordo di convivenza',
  'templates.starter.photography.name': 'Contratto di servizi fotografici',
  'templates.starter.photography.scopeTitle': 'Contratto di servizi fotografici',
  'templates.starter.shortterm-rental.name': 'Contratto di affitto a breve termine',
  'templates.starter.shortterm-rental.scopeTitle': 'Contratto di affitto a breve termine',
  'templates.starter.equipment-rental.name': 'Contratto di noleggio attrezzature',
  'templates.starter.equipment-rental.scopeTitle': 'Contratto di noleggio attrezzature',
  'templates.starter.independent-contractor.name': 'Contratto di appaltatore indipendente',
  'templates.starter.independent-contractor.scopeTitle': 'Contratto di appaltatore indipendente',
}
